export const imagePreviewHashtagText = 'ImageDisplayed';
